<dx-data-grid (onToolbarPreparing)="onGridToolbarPreparing($event)"
              [dataSource]="model"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [allowColumnResizing]="true"
              noDataText="{{ 'keine anderen Verpackungseinheiten' | translate }}"
              [showBorders]="true"
              (onRowRemoving)="onRowRemoving($event)"
              (onRowRemoved)="delete($event)"
              [masterDetail]="{ enabled: true, template: 'detail' }"
              (onContentReady)="onContentReady($event)"
              [customizeColumns]="customizeColumns">
  <div *dxTemplate="let toolbaritem of 'newPackingButtonTemplate'">
    <dx-button *ngIf="renderNewPackingButton()"
               stylingMode="text"
               [disabled]="updateLock || readOnly('packNew')"
               type="default"
               text="{{ 'Neue Verkaufseinheit' | translate }}"
               (onClick)="addPacking()"></dx-button>
  </div>

  <div *dxTemplate="let toolbaritem of 'refreshButtonTemplate'">
    <dx-button *ngIf="!templateView" stylingMode="text" type="default" icon="refresh" (onClick)="reload()"></dx-button>
  </div>

  <dxo-editing mode="cell"
               [allowUpdating]="!readOnly('packUpdate')"
               [allowDeleting]="allowDeleting && !readOnly('mimeDelete')"
               [useIcons]="true">
    <dxo-texts confirmDeleteMessage="" confirmDeleteTitle=""></dxo-texts>
  </dxo-editing>

  <dxo-state-storing [enabled]="true" type="localStorage" storageKey="SalesUnitState"></dxo-state-storing>

  <dxi-column dataField="order"
              caption="{{ 'Order' | translate }}"
              [width]="80"
              [allowEditing]="true"
              cellTemplate="packingOrderTemplate"
              editCellTemplate="packingOrderTemplate"></dxi-column>
  <div *dxTemplate="let packing of 'packingOrderTemplate'">
    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="false"
                       [showPlaceLabel]="packing?.data?.order != null"
                       [suppressLabel]="true"
                       [suppressLinkButton]="true"
                       [suppressTranslation]="true"
                       [suppressToolTip]="true"
                       [suppressDragHandle]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="null"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Order' | translate }}"
                       field="templateService.fieldNames.packingOrder"
                       [system]="packing.data.order.toString()"
                       [showDragHandle]="false"
                       [dragFilter]="dragFilter">
        <div slot="content" class="contentSlot">
          <dx-number-box *ngIf="showLinkButtons"
                         class="inDataGrid"
                         [(value)]="packing.data.order"
                         [min]="1"
                         [showSpinButtons]="!hasFieldLinked(packing?.data?.order.toString())"
                         [readOnly]="hasFieldLinked(packing?.data?.order.toString()) || readOnly(templateService.fieldNames.packingOrder)"
                         [showClearButton]="false"
                         valueChangeEvent="focusout"
                         (onValueChanged)="update($event, null, packing?.data, templateService.fieldNames.packingOrder, packing.data.order.toString())"></dx-number-box>
          <dx-number-box *ngIf="!showLinkButtons"
                         class="inDataGrid"
                         [(value)]="packing.data.order"
                         [min]="1"
                         [showSpinButtons]="!templateView"
                         [readOnly]="readOnly(templateService.fieldNames.packingOrder)"
                         [showClearButton]="false"
                         (onValueChanged)="update($event, null, packing.data, templateService.fieldNames.packingOrder, packing.data.order.toString())"></dx-number-box>
        </div>
      </np-inputControl>
    </div>
  </div>

  <dxi-column dataField="unit"
              caption="{{ 'Einheit' | translate }}"
              [allowEditing]="true"
              cellTemplate="unitTemplate"
              editCellTemplate="unitTemplate"></dxi-column>
  <div *dxTemplate="let packing of 'unitTemplate'">
    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="packing?.data?.unit?.length > 0"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, packing.data.order.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Einheit' | translate }}"
                       [field]="templateService.fieldNames.packingUnit"
                       [system]="packing.data.order.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">
        <div slot="content" class="contentSlot">
          <np-dropdown-control fieldName="templateService.fieldNames.packingUnit"
                               [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingUnit, packing.data.order.toString()) || readOnly(templateService.fieldNames.packingUnit)"
                               [templateView]="templateView"
                               validationGroup="PACKING"
                               [validationCallback]="validationService.validateField(templateService.fieldNames.packingUnit)"
                               [items]="unitDataSource"
                               [(value)]="packing.data.unit"
                               (onValueChanged)="update($event, null, null, templateService.fieldNames.packingUnit, packing.data.order.toString())"
                               (onCustomItemCreating)="onCustomItemCreating($event, packing.data.order)">
          </np-dropdown-control>
        </div>
      </np-inputControl>
    </div>
  </div>

  <dxi-column dataField="supplierPid"
              caption="{{ 'Artikelnummer' | translate }}"
              [allowEditing]="true"
              cellTemplate="supplierPidTemplate"
              editCellTemplate="supplierPidTemplate"></dxi-column>
  <div *dxTemplate="let packing of 'supplierPidTemplate'">
    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="packing?.data?.supplierPid?.length > 0"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, packing.data.order.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Artikelnummer' | translate }}"
                       [field]="templateService.fieldNames.packingSupplierPid"
                       [system]="packing.data.order.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">
        <div slot="content" class="contentSlot">
          <dx-text-box [(value)]="packing.data.supplierPid"
                       [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingSupplierPid, packing.data.order.toString()) || readOnly(templateService.fieldNames.packingSupplierPid)"
                       [showClearButton]="!readOnlyForLinkedFields(templateService.fieldNames.packingSupplierPid, packing.data.order.toString())"
                       (onValueChanged)="update($event, null, null, templateService.fieldNames.packingSupplierPid, packing.data.order.toString())">
            <dx-validator *ngIf="!templateView && product"
                          validationGroup="PACKING"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="required"
                                   message="{{ 'Artikelnummer ist ein Pflichtfeld' | translate }}"></dxi-validation-rule>
              <dxi-validation-rule type="async"
                                   [validationCallback]="validationService.validateField(templateService.fieldNames.packingSupplierPid, packing.data.order.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </np-inputControl>
    </div>
  </div>

  <dxi-column dataField="internationalPid"
              caption="{{ 'International-ID' | translate }}"
              [allowEditing]="true"
              cellTemplate="internationalPidTemplate"
              editCellTemplate="internationalPidTemplate"></dxi-column>
  <div *dxTemplate="let packing of 'internationalPidTemplate'">
    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="packing?.data?.internationalPid?.length > 0"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, packing.data.order.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'International-ID' | translate }}"
                       [field]="templateService.fieldNames.packingInternationalPid"
                       [system]="packing.data.order.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">
        <div slot="content" class="contentSlot">
          <dx-text-box [(value)]="packing.data.internationalPid"
                       [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingInternationalPid, packing.data.order.toString()) || readOnly(validationService.fieldNames.packInternationalPid)"
                       [showClearButton]="!readOnlyForLinkedFields(templateService.fieldNames.packingInternationalPid, packing.data.order.toString())"
                       (onValueChanged)="update($event, null, null, templateService.fieldNames.packingInternationalPid, packing.data.order.toString())">
            <dx-validator *ngIf="!templateView && product"
                          validationGroup="PACKING"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async"
                                   [validationCallback]="validationService.validateField(templateService.fieldNames.packingInternationalPid, packing.data.order.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </np-inputControl>
    </div>
  </div>

  <dxi-column dataField="quantityMin"
              caption="{{ 'Menge' | translate }}"
              [width]="80"
              [allowEditing]="true"
              cellTemplate="packingQuantityMinTemplate"
              editCellTemplate="packingQuantityMinTemplate"></dxi-column>
  <div *dxTemplate="let packing of 'packingQuantityMinTemplate'">
    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="packing?.data?.quantityMin != null"
                       [suppressLabel]="true"
                       [suppressTranslation]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, packing.data.order.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Menge' | translate }}"
                       [field]="templateService.fieldNames.packingQuantityMin"
                       [system]="packing.data.order.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">
        <div slot="content" class="contentSlot">
          <dx-number-box *ngIf="showLinkButtons"
                         class="inDataGrid"
                         [value]="getQuantityMin(packing.data)"
                         format="#0.#####"
                         [showSpinButtons]="!hasFieldLinked(packing?.data?.order.toString())"
                         [readOnly]="hasFieldLinked(packing?.data?.order.toString()) || readOnly(templateService.fieldNames.packingQuantityMin)"
                         [showClearButton]="false"
                         valueChangeEvent="focusout"
                         (onValueChanged)="setQuantityMin(packing.data, $event.value); update($event, null, packing?.data, templateService.fieldNames.packingQuantityMin, packing.data.order.toString())"></dx-number-box>
          <dx-number-box *ngIf="!showLinkButtons"
                         class="inDataGrid"
                         [value]="getQuantityMin(packing.data)"
                         format="#0.#####"
                         [showSpinButtons]="!templateView"
                         [readOnly]="readOnly(templateService.fieldNames.packingQuantityMin)"
                         [showClearButton]="false"
                         (onValueChanged)="setQuantityMin(packing.data, $event.value); update($event, null, packing.data, templateService.fieldNames.packingQuantityMin, packing.data.order.toString())">
            <dx-validator *ngIf="!templateView && product"
                          validationGroup="PACKING"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async"
                                   [validationCallback]="validationService.validateField(templateService.fieldNames.packingQuantityMin, packing.data.order.toString())"></dxi-validation-rule>
            </dx-validator>

          </dx-number-box>
        </div>
      </np-inputControl>
    </div>
  </div>

  <div *dxTemplate="let packing of 'detail'">
    <div class="np-form-control dx-fieldset">
      <div class="row g-3">
        <div class="col-12 col-lg-4 np-field">
          <np-inputControl [(model)]="product"
                           [showLinkButtons]="showLinkButtons"
                           [showPlaceLabel]="packing?.data?.width != null"
                           [suppressTranslation]="true"
                           [suppressToolTip]="true"
                           [(selectedElements)]="selectedElements"
                           (elementSelected)="templateSelect($event, packing.data.order.toString())"
                           (onValueChanged)="update($event)"
                           labelText="{{ 'Verpackungsbreite (Meter)' | translate }}"
                           [field]="templateService.fieldNames.packingWidth"
                           [system]="packing.data.order.toString()"
                           [showDragHandle]="showDragHandle"
                           [dragFilter]="dragFilter"
                           (excelElementDropped)="excelElementDrop($event)">
            <div slot="content" class="contentSlot">
              <dx-number-box [(value)]="packing.data.width"
                             [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingWidth, packing.data.order.toString()) || readOnly(templateService.fieldNames.packingWidth)"
                             [showClearButton]="false"
                             (onValueChanged)="update($event, null, packing.data, templateService.fieldNames.packingWidth, packing.data.order.toString())">
                <dx-validator *ngIf="!templateView && product"
                              validationGroup="PACKING"
                              (onInitialized)="validationService.startAutomaticValidation($event)">
                  <dxi-validation-rule type="async"
                                       [validationCallback]="validationService.validateField(templateService.fieldNames.packingWidth, packing.data.order.toString())"></dxi-validation-rule>
                </dx-validator>
              </dx-number-box>
            </div>
          </np-inputControl>
        </div>

        <div class="col-12 col-lg-4 np-field">
          <np-inputControl [(model)]="product"
                           [showLinkButtons]="showLinkButtons"
                           [showPlaceLabel]="packing?.data?.length != null"
                           [suppressTranslation]="true"
                           [suppressToolTip]="true"
                           [(selectedElements)]="selectedElements"
                           (elementSelected)="templateSelect($event, packing.data.order.toString())"
                           (onValueChanged)="update($event)"
                           labelText="{{ 'Verpackungslänge (Meter)' | translate }}"
                           [field]="templateService.fieldNames.packingLength"
                           [system]="packing.data.order.toString()"
                           [showDragHandle]="showDragHandle"
                           [dragFilter]="dragFilter"
                           (excelElementDropped)="excelElementDrop($event)">
            <div slot="content" class="contentSlot">
              <dx-number-box [(value)]="packing.data.length"
                             [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingLength, packing.data.order.toString()) || readOnly(templateService.fieldNames.packingLength)"
                             [showClearButton]="false"
                             (onValueChanged)="update($event, null, packing.data, templateService.fieldNames.packingLength, packing.data.order.toString())">
                <dx-validator *ngIf="!templateView && product"
                              validationGroup="PACKING"
                              (onInitialized)="validationService.startAutomaticValidation($event)">
                  <dxi-validation-rule type="async"
                                       [validationCallback]="validationService.validateField(templateService.fieldNames.packingLength, packing.data.order.toString())"></dxi-validation-rule>
                </dx-validator>
              </dx-number-box>
            </div>
          </np-inputControl>
        </div>

        <div class="col-12 col-lg-4 np-field">
          <np-inputControl [(model)]="product"
                           [showLinkButtons]="showLinkButtons"
                           [showPlaceLabel]="packing?.data?.depth != null"
                           [suppressTranslation]="true"
                           [suppressToolTip]="true"
                           [(selectedElements)]="selectedElements"
                           (elementSelected)="templateSelect($event, packing.data.order.toString())"
                           (onValueChanged)="update($event)"
                           labelText="{{ 'Verpackungstiefe (Meter)' | translate }}"
                           [field]="templateService.fieldNames.packingDepth"
                           [system]="packing.data.order.toString()"
                           [showDragHandle]="showDragHandle"
                           [dragFilter]="dragFilter"
                           (excelElementDropped)="excelElementDrop($event)">
            <div slot="content" class="contentSlot">
              <dx-number-box [(value)]="packing.data.depth"
                             [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingDepth, packing.data.order.toString()) || readOnly(templateService.fieldNames.packingDepth)"
                             [showClearButton]="false"
                             (onValueChanged)="update($event, null, packing.data, templateService.fieldNames.packingDepth, packing.data.order.toString())">
                <dx-validator *ngIf="!templateView && product"
                              validationGroup="PACKING"
                              (onInitialized)="validationService.startAutomaticValidation($event)">
                  <dxi-validation-rule type="async"
                                       [validationCallback]="validationService.validateField(templateService.fieldNames.packingDepth, packing.data.order.toString())"></dxi-validation-rule>
                </dx-validator>
              </dx-number-box>
            </div>
          </np-inputControl>
        </div>

        <div class="col-12 col-lg-4 np-field">
          <np-inputControl [(model)]="product"
                           [showLinkButtons]="showLinkButtons"
                           [showPlaceLabel]="packing?.data?.weight != null"
                           [suppressTranslation]="true"
                           [suppressToolTip]="true"
                           [(selectedElements)]="selectedElements"
                           (elementSelected)="templateSelect($event, packing.data.order.toString())"
                           (onValueChanged)="update($event)"
                           labelText="{{ 'Verpackungsgewicht (KG)' | translate }}"
                           [field]="templateService.fieldNames.packingWeight"
                           [system]="packing.data.order.toString()"
                           [showDragHandle]="showDragHandle"
                           [dragFilter]="dragFilter"
                           (excelElementDropped)="excelElementDrop($event)">
            <div slot="content" class="contentSlot">
              <dx-number-box [(value)]="packing.data.weight"
                             [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingWeight, packing.data.order.toString()) || readOnly(templateService.fieldNames.packingWeight)"
                             [showClearButton]="false"
                             (onValueChanged)="update($event, null, packing.data, templateService.fieldNames.packingWeight, packing.data.order.toString())">
                <dx-validator *ngIf="!templateView && product"
                              validationGroup="PACKING"
                              (onInitialized)="validationService.startAutomaticValidation($event)">
                  <dxi-validation-rule type="async"
                                       [validationCallback]="validationService.validateField(templateService.fieldNames.packingWeight, packing.data.order.toString())"></dxi-validation-rule>
                </dx-validator>
              </dx-number-box>
            </div>
          </np-inputControl>
        </div>

        <div class="col-12 col-lg-4 np-field">
          <np-inputControl [(model)]="product"
                           [showLinkButtons]="showLinkButtons"
                           [showPlaceLabel]="packing?.data?.quantityMax != null"
                           [suppressTranslation]="true"
                           [suppressToolTip]="true"
                           [(selectedElements)]="selectedElements"
                           (elementSelected)="templateSelect($event, packing.data.order.toString())"
                           (onValueChanged)="update($event)"
                           labelText="{{ 'Höchtsmenge' | translate }}"
                           [field]="templateService.fieldNames.packingQuantityMax"
                           [system]="packing.data.order.toString()"
                           [showDragHandle]="showDragHandle"
                           [dragFilter]="dragFilter"
                           (excelElementDropped)="excelElementDrop($event)">
            <div slot="content" class="contentSlot">
              <dx-number-box [(value)]="packing.data.quantityMax"
                             [readOnly]="readOnlyForLinkedFields(templateService.fieldNames.packingQuantityMax, packing.data.order.toString()) || readOnly(templateService.fieldNames.packingQuantityMax)"
                             [showClearButton]="false"
                             (onValueChanged)="update($event, null, packing.data, templateService.fieldNames.packingQuantityMax, packing.data.order.toString())">
                <dx-validator *ngIf="!templateView && product"
                              validationGroup="PACKING"
                              (onInitialized)="validationService.startAutomaticValidation($event)">
                  <dxi-validation-rule type="async"
                                       [validationCallback]="validationService.validateField(templateService.fieldNames.packingQuantityMax, packing.data.order.toString())"></dxi-validation-rule>
                </dx-validator>
              </dx-number-box>
            </div>
          </np-inputControl>
        </div>
      </div>
    </div>
  </div>

</dx-data-grid>

<div *ngIf="modelService.loginService.currentCustomer.automaticValidation && !validationService.validationResult?.productPackingsValid" class="color3Text">
  <table>
    <tr *ngFor="let msg of validationService.validationResult?.packingMessages">
      <td>{{ translateMessage(msg) }}</td>
    </tr>
  </table>
</div>
